/* eslint-disable react-hooks/exhaustive-deps */
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { listarUnidades } from "../api/General";
import { useCatalog } from "../context/Catalog";
import { useTramite } from "../context/Tramite";
import { isInvalid } from "../utils/forms";
import { MesesProduccion, isEditable } from "../utils/tramite";
import "./css/components.css";
import { crearProducto } from "../utils/data";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import QuestionField from "./controls/QuestionField";
import CheckboxField from "./controls/CheckboxField";
import TextareaField from "./controls/TextareaField";
import ArrayField from "./controls/ArrayField";

import { ProductoElaboradoForm } from "./ProductoElaboradoForm";
import { ProductoElaboradoList } from "./ProductoElaboradoList";

export default function ProduccionForm({ ...props }) {
  const { tramite } = useTramite();
  const tramiteForm = useFormikContext();
  const { t } = useTranslation();
  const unidadesCatalog = useCatalog(
    ["unidadesCantidad", "produccion", "TN", "KG", "M3", "UNIDADES", "L"],
    () =>
      listarUnidades({
        codigo: ["TN", "KG", "M3", "UNIDADES", "L"],
      }),
  );
  const loading = unidadesCatalog.loading;
  const handleConEstacionalidadChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleMesesProduccionChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleProcesoProductivoChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleProductosElaboradosChange = (event) => {
    tramiteForm.handleChange(event);
  };
  useEffect(() => {
    if (
      !tramiteForm.values.conEstacionalidad &&
      tramiteForm.values.mesesProduccion?.length < 12
    ) {
      tramiteForm.setFieldValue("mesesProduccion", MesesProduccion);
    }
  }, [tramiteForm.values.conEstacionalidad]);
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="conEstacionalidad"
              name="conEstacionalidad"
              label={t("tramite.conEstacionalidad")}
              value={tramiteForm.values.conEstacionalidad}
              onChange={handleConEstacionalidadChange}
              isInvalid={isInvalid("conEstacionalidad", tramiteForm)}
              error={t(tramiteForm.errors.conEstacionalidad)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <CheckboxField
              id="mesesProduccion"
              name="mesesProduccion"
              lg={4}
              label={t("tramite.mesesProduccion")}
              value={tramiteForm.values.mesesProduccion}
              onChange={handleMesesProduccionChange}
              options={MesesProduccion}
              isInvalid={isInvalid("mesesProduccion", tramiteForm)}
              error={t(tramiteForm.errors.mesesProduccion)}
              disabled={
                !isEditable(tramite) || !tramiteForm.values.conEstacionalidad
              }
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextareaField
              id="procesoProductivo"
              name="procesoProductivo"
              label={t("tramite.procesoProductivo")}
              value={tramiteForm.values.procesoProductivo}
              onChange={handleProcesoProductivoChange}
              rows={12}
              isInvalid={isInvalid("procesoProductivo", tramiteForm)}
              maxLength={1024}
              error={t(tramiteForm.errors?.procesoProductivo)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ArrayField
              id="productosElabrorados"
              name="productosElaborados"
              label={t("tramite.productosElaborados")}
              value={tramiteForm.values.productosElaborados}
              onChange={handleProductosElaboradosChange}
              createItem={crearProducto}
              isInvalid={isInvalid("productosElaborados", tramiteForm)}
              error={
                (tramiteForm.errors.productosElaborados instanceof Array &&
                  t("errors.tramite.productosElaborados.many")) ||
                t(tramiteForm.errors.productosElaborados)
              }
              disabled={!isEditable(tramite)}
            >
              {({
                value: productosElaborados,
                append,
                replace,
                remove,
                select,
                selectedIndex,
                selectedItem,
                disabled,
              }) => (
                <Grid>
                  {!disabled && (
                    <Row>
                      <Col lg={12}>
                        <ProductoElaboradoForm
                          value={selectedItem}
                          page={selectedIndex}
                          pages={productosElaborados.length}
                          select={select}
                          append={append}
                          replace={replace}
                          remove={remove}
                          operacionesUnitarias={
                            tramiteForm.values.operacionesUnitarias
                          }
                          unidadesCantidad={unidadesCatalog.data}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col lg={12}>
                      <ProductoElaboradoList
                        value={productosElaborados}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
